import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { settingsApi } from "@/api";
import { useLang } from "@/i18n";
import { MyDataSettings } from "@/components/MyDataSettings";
import { RegistrySettings } from "@/components/RegistrySettings";

const FIELDS = [
  ["name", "company_name"], ["activity", "activity"], ["afm", "vat_id"], ["doy", "tax_office"],
  ["address", "address"], ["city", "city"], ["postal_code", "postal_code"], ["phone", "phone"], ["email", "email"], ["iban", "iban"],
  ["ame", "ame"], ["kad", "kad"],
];

export default function Settings() {
  const { t } = useLang();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { settingsApi.get().then(setForm); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try { await settingsApi.update(form); toast.success(t("settings_saved")); }
    catch { toast.error(t("error")); } finally { setSaving(false); }
  };

  if (!form) return null;

  return (
    <div className="space-y-6">
    <form onSubmit={submit} className="erp-card p-6 max-w-3xl space-y-5 page-enter" data-testid="settings-page">
      <div>
        <h1 className="text-2xl font-heading font-extrabold tracking-tight">{t("company_settings")}</h1>
        <p className="text-sm text-slate-500 mt-1">{t("company_settings_hint")}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {FIELDS.map(([key, label]) => (
          <div key={key} className={`space-y-1.5 ${["name", "activity", "address", "iban"].includes(key) ? "sm:col-span-2" : ""}`}>
            <Label className="text-xs uppercase tracking-wider text-slate-500">{t(label)}</Label>
            <Input value={form[key] || ""} onChange={(e) => setForm({ ...form, [key]: e.target.value })}
              className={["afm", "phone", "iban", "ame", "kad", "postal_code"].includes(key) ? "font-mono" : ""} data-testid={`settings-${key}-input`} />
          </div>
        ))}
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={saving} className="bg-blue-800 hover:bg-blue-700" data-testid="settings-submit-button">{t("save")}</Button>
      </div>
    </form>
    <MyDataSettings />
    <RegistrySettings />
    </div>
  );
}
